import { createClient } from '@supabase/supabase-js';

// Get Supabase credentials from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Check if credentials are configured
if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '⚠️ Supabase credentials are missing!\n\n' +
    'Please follow these steps:\n' +
    '1. Go to https://supabase.com/dashboard\n' +
    '2. Select your project or create a new one\n' +
    '3. Go to Settings → API\n' +
    '4. Copy your Project URL and anon/public key\n' +
    '5. Add them to your .env file:\n\n' +
    'REACT_APP_SUPABASE_URL=your-project-url\n' +
    'REACT_APP_SUPABASE_ANON_KEY=your-anon-key\n\n' +
    '6. Restart your development server (npm start)\n'
  );
}

// Create and export the Supabase client with fallback for development
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
      storageKey: 'supabase.auth.token',
      flowType: 'pkce'
    }
  }
);
